module.exports = "<div class=\"signing-in\">{{ authService.getLoginStatus() || 'Signing in...' }}</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/auth/views/microsoftLoginView/microsoftLoginView.component.html
// module id = ./src/app/modules/auth/views/microsoftLoginView/microsoftLoginView.component.html
// module chunks = main